import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { localStorageKeys } from 'src/app/services/localStorage/localStorageVariables';
import { ThemeService } from 'src/app/services/client/theme/theme.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { NavController } from '@ionic/angular';
import { PageStateService } from 'src/app/services/page-state.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @Input() PageType?: string;
  public appLogo: string;
  public loginText: string;
  public isGuestUser: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private navController: NavController,
    private themeService: ThemeService,
    private authService: AuthenticationService,
    private pageStateService: PageStateService
  ) {
    this.appLogo = this.themeService.getAppLogo?.blackLogo;
  }

  ngOnInit() {
    try {
      this.isGuestUser = this.authService.checkIfGuestUser();
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      this.isGuestUser = true; // Default to guest user on error
    }

    if(this.themeService.getClientName === 'thomascook_fc' || this.themeService.getClientName === 'thomascook_lt') {
      this.loginText = 'Thomas Cook ancillary services in partnership with Travel VIP'
      this.appLogo = this.themeService.getAppLogo?.whiteLogo;
    } else {
      this.loginText = 'Travel VIP ancillary services';
    }
  }

  verifyLogin() {
    if (this.isGuestUser) {
      this.authService.transferGuestToken();
      this.pageStateService.setReloadAll()
      this.router.navigate(['/', 'login']);
    } else {
      this.router.navigate(['/', 'home']);
    }
  }

  navigateToHome(){
    this.navController.navigateForward(['/home']);
  }
}
